import "src/styles/gridSystem.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/styles/gridSystem.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAACs1VwW6jMBC95yvmslKykpGBwAb30l9xsANewEaGbZJW/feVDbiG0qJ2L3sB8WbmzZvxjAnuTdUkUQYvO4CG6kJIVPNLTyCndb5/onqPUMsO8BNQeHh4c9KiKD/xYqJra3oncKn5zQDmja6atgTM0zIJiUo+8GT4qXzYve6CQQ8d9dzQVbC+JBBGKW4tUUsZE7IYVYbJHB1lTfC2DJfybFN+gd1F5jYSoeELE+g1lV1LNZe9y1lodSWA3XdXaiErHznTTnQE4h8GOdO8KrT6IxnKVa00gaHJYw7b42ckJOM3AkdPDJuJiQhgyzcB4T+q81VE4zy4Q3pvtLlEL5QkQOsacBB3wGnHt2s0c+Sq4rYqI4QABgxxHMRDo7z0E+iiLouoNA3SdBk1gS6qWEQleBliEedfOv/vtTH+rI2DcT6Vvv243eZnpZp5UOK3Vlj5g1Po4b8tPu1naPcToFVTnq4XeXW32VU7lugmMssy7HFVlmupMsK4mWQ613plDX2qZsWe4Nk+Sq8iHPxKPJNaFvvYcCYodLnmXAKVDPbmWppuHRwd29thxL3bKD2dDG7IZlOwfVQfnQfA6xuZGMmcUGPdFPtfivqog9EJL8TWq2LxQkWz6pWMPwfPUc7kDnMwc1Dfque9brnGs5HlL3zTs8l3BwAA\"}!../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var SCCol = 'ymkm52b';
export var SCCol1 = 'ymkm52c';
export var SCCol2 = 'ymkm52d';
export var SCCol4 = 'ymkm52e';
export var SCCol5 = 'ymkm52f';
export var SCCol6 = 'ymkm52g';
export var SCCol8 = 'ymkm52h';
export var SCFull = 'ymkm52a';
export var SCFullScreen = 'ymkm52j';
export var SCGrid = 'ymkm528';
export var SCRow = 'ymkm529';
export var baseCol8 = 'ymkm52k';
export var noZoomScale = 'ymkm52i';
export var paddingLeft0 = 'ymkm52l';
export var paddingLeft50 = 'ymkm52m';
export var size = {mobileS:'320px',mobileM:'375px',mobileL:'425px',tablet:'768px',laptop:'1024px',laptopL:'1440px',desktop:'1688px'};
export var vColor1 = 'var(--ymkm520)';
export var vColor2 = 'var(--ymkm521)';
export var vLeftWidth = 'var(--ymkm522)';
export var vPadLeft = 'var(--ymkm524)';
export var vRightWidth = 'var(--ymkm523)';
export var vZoom = 'var(--ymkm525)';
export var vZoomDesktop = 'var(--ymkm527)';
export var vZoomLaptop = 'var(--ymkm526)';
export var zoom075 = 'ymkm52n';
export var zoom1 = 'ymkm52o';